// removed by extract-text-webpack-plugin
module.exports = {"warp":"pages-UploadW9Anon-warp","secordTitle":"pages-UploadW9Anon-secordTitle","descContent":"pages-UploadW9Anon-descContent"};


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/UploadW9Anon/UploadW9Anon.css
// module id = 1822
// module chunks = 0